import script from "./ArgonStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonStatus.vue?vue&type=script&setup=true&lang=js"

import "./ArgonStatus.vue?vue&type=style&index=0&id=76c1e2f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76c1e2f7"]])

export default __exports__